import { format, toZonedTime } from "date-fns-tz";
import AccountTransaction from "../Component/Report/AccountTransaction";
import UserReport from "../Component/Report/UserReport";

export const productList = [
  { value: "EASYREMIT", label: "Easy Remit" },
  { value: "INVESTING", label: "Investing" },
  { value: "MCB", label: "Mcb" },
  { value: "ADMIN", label: "Admin" },
];

export const featureMapping = {
  INV_CUSTOMER_WRITE: "customer-editable",
  ER_COUPONS_WRITE: "coupons-editable",
  ER_DOCUMENT_WRITE: "Document-editable",
  ER_QUOTE_WRITE: "QuoteId-search",
  MCB_USERS_WRITE: "Mcb-users",
  INV_REPORTS_WRITE: "Report",
};

export const formatDateAndTime = (dateUTC) => {
  if (!dateUTC) return "--";

  const date = new Date(dateUTC);
  if (isNaN(date.getTime())) return "--";

  const zonedDate = toZonedTime(date, "Asia/Kolkata");
  return format(zonedDate, "dd/MM/yyyy, hh:mm:ss a '(IST)'", { timeZone: "Asia/Kolkata" });
};

export const buildFilterParams = (mcbStatus, startDate, endDate, partnerCd = "") => {
  const filters = {};

  if (mcbStatus) {
    filters.status = mcbStatus;
  }

  if (startDate) {
    filters.fromDate = format(startDate, "yyyy-M-d");
  }

  if (endDate) {
    filters.toDate = format(endDate, "yyyy-M-d");
  }

  if (partnerCd) {
    filters.partnerCd = partnerCd;
  }

  return Object.keys(filters).length > 0 ? JSON.stringify(filters) : "";
};

export const downloadPdf = (path) => {
  const link = document.createElement("a");
  link.href = path;
  link.download = "";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getCurrencySymbol = (currency) => {
  const symbols = {
    USD: "U$",
    EUR: "€",
    GBP: "£",
    SGD: "S$",
    AUD: "A$",
    CAD: "C$",
  };
  return symbols[currency] || currency;
};

export const transactionTypeMap = {
  ACATS_CASH: "ACATS CASH",
  COMM: "Commission",
  CSD: "Withdrawal",
  CSR: "Deposit",
  DEL: "DEL",
  DIV: "Dividend",
  DIVM: "DIVM",
  DIVTAX: "Dividend Tax",
  FEE: "Fees",
  INT: "Interest",
  JNLC: "JNLC",
  MERGER_ACQUISITION: "Merger Acquisition",
  PTP_WITHHOLDING: "PTP Withholding",
  REC: "REC",
  SLIP: "SLIP",
  SLIPNRA: "SLIPNRA",
  SPINOFF: "SPINOFF",
  SPUR: "Buy",
  SSAL: "Sell",
  STCK: "STCK",
  STOCK_SPLIT: "Stock Split",
  XTRF: "XTRF",
};

export const finTranTypeID = {
  ACATS_CASH: "ACATS CASH",
  COMM: "Commission",
  CSD: "Withdrawal",
  CSR: "Deposit",
  DEL: "DEL",
  DIV: "Dividend",
  DIVM: "DIVM",
  DIVTAX: "Dividend Tax",
  FEE: "Fees",
  INT: "Interest",
  JNLC: "JNLC",
  MERGER_ACQUISITION: "Merger Acquisition",
  PTP_WITHHOLDING: "PTP Withholding",
  REC: "REC",
  SLIP: "SLIP",
  SLIPNRA: "SLIPNRA",
  SPINOFF: "SPINOFF",
  SPUR: "Buy",
  SSAL: "Sell",
  STCK: "STCK",
  STOCK_SPLIT: "Stock Split",
  XTRF: "XTRF",
};

export const ReportType = {
  report: [
    { name: "Account Transaction Report", Component: AccountTransaction },
  ],
  download: [{ name: "User Reports", Component: UserReport }],
};


export const objectiveLabels = {
  LONG_TERM: "Long Term",
  INFREQUENT: "Infrequent",
  FREQUENT: "Frequent",
  ACTIVE_DAILY: "Active Daily",
  NEW: "New",
};

export const experienceLabels = {
  NONE: "None",
  YRS_1_2: "1-2 Yrs",
  YRS_3_5: "3-5 Yrs",
  YRS_5_10: "5-10 Yrs",
  YRS_10_: "10+ Yrs",
};

export const riskToleranceLabels = {
  LOW: "Low",
  MODERATE: "Moderate",
  SPECULATION: "Speculation",
  HIGH: "High",
};

export const usTaxPayerLabels = {
  true: "Yes",
  false: "No",
};

export const makeOptions = (labels) =>
  Object.entries(labels).map(([value, label]) => ({ value, label }));

export const objectivesOptions = makeOptions(objectiveLabels);
export const experienceOptions = makeOptions(experienceLabels);
export const riskToleranceOptions = makeOptions(riskToleranceLabels);
export const usTaxPayerOptions = makeOptions(usTaxPayerLabels);


export const employeeTypeOptions = [
  { value: "AGRICULTURE", label: "Agriculture, Forestry, Fishing and Hunting" },
  { value: "MINING", label: "Mining, Quarrying, and Oil and Gas Extraction" },
  { value: "UTILITIES", label: "UTILITIES" },
  { value: "CONSTRUCTION", label: "Construction" },
  { value: "MANUFACTURING", label: "Manufacturing" },
  { value: "WHOLESALE", label: "Wholesale Trade" },
  { value: "RETAIL", label: "Retail Trade" },
  { value: "TRANSPORT", label: "Transportation and Warehousing" },
  { value: "INFORMATION", label: "Information" },
  { value: "FINANCE", label: "Finance and Insurance" },
  { value: "REAL_ESTATE", label: "Real Estate and Rental and Leasing" },
  {
    value: "PROFESSIONAL",
    label: "Professional, Scientific, and Technical Services",
  },
  { value: "MANAGEMENT", label: "Management of Companies and Enterprises" },
  { value: "EDUCATION", label: "Educational Services" },
  { value: "HEALTH", label: "Health Care and Social Assistance" },
  { value: "ART", label: "Arts, Entertainment, and Recreation" },
  { value: "FOOD", label: "Accommodation and Food Services" },
  { value: "PUBLIC", label: "Public Administration" },
  {
    value: "WASTE",
    label:
      "Administrative and Support and Waste Management and Remediation Services",
  },
];

export const employmentPositionOptions = [
  "ACCOUNTANT","ACTUARY","ADJUSTER","ADMINISTRATOR","ADVERTISER", "AGENT","ATC","AMBASSADOR","ANALYST","APPRAISER","ARCHITECT","ARTIST","ASSISTANT",
  "ATHLETE","ATTENDANT","ATTORNEY","AUCTIONEER","AUDITOR","BARBER","BROKER","BUSINESS_EXEC","BUSINESS_OWNER","CAREGIVER","CARPENTER","CASHIER",
  "CHEF","CHIROPRACTOR","CIVIL","CLERGY","CLERK","COMPLIANCE","CONSULTANT","CONTRACTOR","COUNSELOR","CUSTOMER_SERVICE","DEALER","DEVELOPER","DISTRIBUTOR",
  "DOCTOR","DRIVER","ENGINEER","EXAMINER","EXTERMINATOR","FACTORY","FARMER","FINANCIAL","FISHERMAN","FLIGHT","HR","IMPEX","INSPECTOR","INTERN",
  "INVESTMENT","INVESTOR","IT","JANITOR","JEWELER","LABORER","LANDSCAPER","LENDING","MANAGER","MECHANIC","MILITARY","MORTICIAN","NURSE","NUTRITIONIST",
  "OFFICE","PHARMACIST","PHYSICAL","PILOT","POLICE","POLITICIAN","PM","REP","RESEARCHER","SAILOR","SALES","SCIENTIST","SEAMSTRESS","SECURITY",
  "SOCIAL","TEACHER","TECHNICIAN","TELLER","TRADESPERSON","TRAINER","TRANSPORTER","UNDERWRITER","WRITER",
];

export const empStatusList = [
    "EMPLOYED",
    "RETIRED",
    "STUDENT",
    "UNEMPLOYED",
    "SELF_EMPLOYED",
  ];
  
export const fieldLabels = {
  employmentCompany: "Employment Company",
  employmentStatus: "Employment Status",
  employmentType: "Employment Type",
  employmentPosition: "Employment Position",
  directorOf: "Director/Officer of Company",
  isBroker: "Brokerage Firm",
};

  export const productType = {
    INVESTING: "INVESTING",
    MCB: "MCB",
    EASY_REMIT: "EASY-REMIT",
    ALL: "ALL",
};

export const idTypeOptions = [
  // { label: "SSN", value: "SSN" },
  { label: "PAN", value: "PAN" },
  { label: "Other", value: "OTHER" },
];

export const discountTypes = [
  { label: "FLAT", value: "FLAT" },
  { label: "PERCENT", value: "PERCENT" },
  { label: "DISCOUNT", value: "DISCOUNT" },
];

export const couponStatusList = [
  { label: "ACTIVE", value: "ACTIVE" },
  { label: "INACTIVE", value: "INACTIVE" },
];

export const infoSteps = {
  "Register": "User has created username and password",
  "Personal Info": "User has filled his basic details",
  "Signup": "User has completed address details",
  "Doc Upload": "User has completed passport upload",
  "Selfie": "User has completed his Video KYC",
  "Submitted": "User account has been submitted for KYC approval",
  "Active": "User’s KYC has been approved",
};

const getDisplayStatus = (currentStep, status) => {
  let displayStatus = status;

  if (
    [
      "REGISTER",
      "PERSONAL_INFO",
      "SIGNUP",
      "DOC_UPLOAD",
      "SELFIEE_UPLOAD",
    ].includes(currentStep)
  ) {
    displayStatus = "ONBOARDING";
  } else if (["SUBMIT", "SUBMITTED"].includes(currentStep)) {
    displayStatus = "PENDING";
  } else if (currentStep === "ACTIVE") {
    displayStatus = "APPROVED";
  }

  return formatText(displayStatus);
};

export const formatText = (text) => {
  if (!text || typeof text !== "string") return text;

  return text
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const getPersonalDetails = (userDetails) => [
  { label: "Full Name", value: userDetails?.name },
  { label: "Username", value: userDetails?.username },
  { label: "User ID", value: userDetails?.userId },
  { label: "First Name", value: userDetails?.firstName },
  { label: "Middle Name", value: userDetails?.middleName },
  { label: "Last Name", value: userDetails?.lastName },
  { label: "Status", value: getDisplayStatus( userDetails?.currentStep, userDetails?.status ),},
  { label: "Completed Step", value: formatText(userDetails?.currentStep), showInfo: true, },
  { label: "Date of Birth", value: userDetails?.dateOfBirth },
  { label: "PAN Number", value: userDetails?.panNumber },
  { label: "Created At", value: formatDateAndTime(userDetails?.createdAt) },
  { label: "Updated At", value: formatDateAndTime(userDetails?.updatedAt) },
  { label: "Submitted At", value: formatDateAndTime(userDetails?.submittedAt) },
  { label: "Approved At", value: formatDateAndTime(userDetails?.approvedAt) },
];

export const getContactDetails = (userDetails) => [
  // { label: "Completed Step", value: userDetails?.currentStep },
  { label: "Email", value: userDetails?.email },
  { label: "Phone Number", value: userDetails?.mobile },
  { label: "Address", value: userDetails?.address, isAddress: true },
  { label: "City", value: userDetails?.city },
  { label: "State", value: userDetails?.state },
  { label: "Country Code", value: userDetails?.countryCode },
  { label: "Postcode", value: userDetails?.postcode },
  { label: "Nationality", value: userDetails?.nationality },
  { label: "2FA Enabled", value: userDetails?.is_2faEnabled ? "Yes" : "No" },
  { label: "T&C Accepted", value: userDetails?.tnc ? "Yes" : "No" },
];

export const getVendorDetails = (vendorData) => [
  { label: "Vendor Client ID", value: vendorData?.vendorClientId },
];

export const ENTITY_OPTIONS = [
  { label: "Individual", value: "INDIVIDUAL" },
  { label: "Business", value: "BUSINESS" },
];
export const Address_Fields = [
   "postcode",
  "street_address",
  "city",
  "state",
];
export const ADDRESS__MAP = {
  postcode: "Postal Code",
  street_address: "Address",
  city: "City",
  state: "State",
};
export const SKIP_DYNAMIC_RENDER = new Set([
  "first_name",
  "last_name",
  "entity_type",
  "country_code",
  "bank_country_code",
  "account_currency",
  "account_name",
  "transfer_method",
  "account_routing_type1",
  "account_routing_type2",
  "nickname",
]);

export const ADDRESS_FIELD_NAMES = new Set([
  "street_address",
  "city",
  "state",
  "postcode",
  "zip_code",
  "province",
  "district",
  "address_line1",
  "address_line2",
]);

export const METHOD_META = {
  LOCAL: {
    title: "Borderless Instant",
    duration: "(0-1 Business Days)",
    charges: "5 USD",
    recommended: true,
  },
  SWIFT: {
    title: "SWIFT",
    duration: "(1-3 Business Days)",
    charges: "15 USD",
    recommended: false,
  },
};

export const INITIAL_FORM = {
  entity_type: "",
  first_name: "",
  last_name: "",
  country_code: "",
  country_name: "",
  account_currency: "",
  bank_country_code: "",
  payment_method: "",
  transfer_method: "",
  account_name: "",
};

export const STEP_MAIN = "main";
export const STEP_ADDRESS = "address";

export const getFirstValidRoutingType = (fields, fieldName) => {
  const field = fields?.find((f) => f.fieldName === fieldName);
  if (!field?.validation) return "";
  if (field.validation.includes("|")) return field.validation.split("|")[0];
  const match = field.validation.match(/\^([^$]+)\$/);
  if (match) return match[1];
  return field.validation.replace(/[^a-zA-Z0-9_]/g, "");
};

export const formatDisplayName = (name = "") =>
  name
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

export const deduplicateFields = (fields = []) => {
  const seen = new Set();
  return fields.filter((f) => {
    if (seen.has(f.fieldName)) return false;
    seen.add(f.fieldName);
    return true;
  });
};

export const capitaliseFirst = (str) => {
  if (typeof str !== "string" || !str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const trimFormData = (formData) =>
  Object.keys(formData).reduce((acc, key) => {
    acc[key] =
      typeof formData[key] === "string" ? formData[key].trim() : formData[key];
    return acc;
  }, {});

export const buildMethodsMap = (methodsFromApi = []) => {
  const sorted = [...methodsFromApi].sort((a, b) => {
    if (a.methodName === "LOCAL") return -1;
    if (b.methodName === "LOCAL") return 1;
    return 0;
  });

  return sorted.reduce((acc, m) => {
    acc[m.methodName] = {
      ...(METHOD_META[m.methodName] || {
        title: m.methodName,
        duration: "",
        charges: "",
        recommended: false,
      }),
      fields: deduplicateFields(m.fields),
    };
    return acc;
  }, {});
};

export const PURPOSE_OPTIONS = [{ label: "Lien Release", value: "Lien Release" }];

export const EMI_PURPOSE_OPTIONS = [
  { label: "EMI deduction", value: "EMI deduction" },
  { label: "EMI bounce charges", value: "EMI bounce charges" },
];

export const getTransferDetails = ({
  name,
  transferMethod = "Borderless Instant",
  remarks,
  transferOn,
  transferFee = "Free",
  transferPurpose = "Lien Release",
  extraDetails = [],
  transferType = "UNLIEN",
}) => {
  let formattedTransferOn = transferOn;

  if (transferOn) {
    formattedTransferOn =
      transferOn.replace(/\b(am|pm)\b/i, (match) => match.toUpperCase()) +
      " (IST)";
  }

  if (transferType === "EMI") {
    return [
      { label: "Name", value: name },
      { label: "Purpose", value: transferPurpose },
      { label: "Remarks", value: remarks },
      { label: "Transfer on", value: formattedTransferOn },
      ...extraDetails,
    ];
  }

  return [
    { label: "Name", value: name },
    { label: "Transfer Method", value: transferMethod },
    { label: "Remarks", value: remarks },
    { label: "Transfer on", value: formattedTransferOn },
    { label: "Transfer Fee", value: transferFee, isGreen: true },
    { label: "Transfer Purpose", value: transferPurpose },
    ...extraDetails,
  ];
};

export const Entity_Type_option = [
  { label: "Individual", value: "PERSONAL" },
  { label: "Business", value: "COMPANY" },
];
